<!-- Show shell only when user is logged in -->
<div class="antialiased bg-gray-50 dark:bg-gray-900 h-full" *ngIf="authQuery.isLoggedIn">
  <nav
    class="rawi-navbar px-4 py-2.5 fixed left-0 right-0 top-0 z-50">
    <div class="flex flex-wrap justify-between items-center">
      <div class="flex justify-start items-center">
        <button
          data-drawer-target="drawer-navigation"
          data-drawer-toggle="drawer-navigation"
          aria-controls="drawer-navigation"
          class="p-2 mr-2 text-white rounded-lg cursor-pointer md:hidden hover:bg-white/10 focus:bg-white/10 focus:ring-2 focus:ring-white/30">
          <svg
            aria-hidden="true"
            class="w-6 h-6"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h6a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clip-rule="evenodd"></path>
          </svg>
          <svg
            aria-hidden="true"
            class="hidden w-6 h-6"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
              clip-rule="evenodd"></path>
          </svg>
          <span class="sr-only">Toggle sidebar</span>
        </button>
        <a routerLink="/dashboard" class="flex items-center justify-between mr-4">
          <img src="./assets/sbk1-logo.svg" class="mr-3 h-12" alt="SmartHACCP" />
        </a>
        <span class="rawi-badge">RAWI – Rattennachschau Wien</span>
      </div>
      <div class="flex items-center lg:order-2">
        <!-- Language selector hidden: system language is fixed to German -->
        <!-- <app-language-selector [icon]="true"></app-language-selector> -->

        <button
          type="button"
          class="flex mx-3 text-sm bg-white rounded-full md:mr-0 focus:ring-4 focus:ring-white/40 dropdown-toggle"
          id="user-menu-button"
          aria-expanded="false"
          data-bs-toggle="dropdown">
          <!-- Show image if available, otherwise show initials -->
          <img 
            *ngIf="profile_image && profile_image.trim() !== '' && profile_image !== 'null' && profile_image !== 'undefined'"
            [src]="profileImageSrc"
            (error)="onImageError($event)"
            class="w-8 h-8 rounded-full object-cover">
          <div 
            *ngIf="!profile_image || profile_image.trim() === '' || profile_image === 'null' || profile_image === 'undefined'"
            class="w-8 h-8 rounded-full bg-white flex items-center justify-center text-sm font-medium"
            style="color: #003580;">
            {{ userInitials }}
          </div>
        </button>
        <!-- Dropdown menu -->
        <div
          class="hidden z-50 my-4 w-56 text-base list-none bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600 rounded-xl dropdown-menu"
          id="dropdown">
          <div class="py-3 px-4">
            <span class="block text-sm font-semibold text-gray-900 dark:text-white">{{ username }}</span>
            <span class="block text-sm text-gray-900 truncate dark:text-white">{{ email }}</span>

            <span *ngIf="role == 1" class="block text-xs italic text-gray-900 dark:text-white"
              >Administrator / {{ role }}</span
            >
            <span *ngIf="role == 2" class="block text-xs italic text-gray-900 dark:text-white">Company Admin / {{ role }}</span>
            <span *ngIf="role == 11" class="block text-xs italic text-gray-900 dark:text-white">{{ 'USER.ROLE.OFFICE' | translate }}</span>
          </div>
          <ul class="py-1 text-gray-700 dark:text-gray-300" aria-labelledby="dropdown">
            <li>
              <a
                routerLink="/support"
                class="block py-2 px-4 text-sm hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white"
                >{{ 'NAV.SUPPORT' | translate }}</a
              >
            </li>
            <li *ngIf="canSeeSettings">
              <a
                routerLink="/settings"
                class="block py-2 px-4 text-sm hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-400 dark:hover:text-white"
                >{{ 'NAV.SETTINGS' | translate }}</a
              >
            </li>
          </ul>

          <ul class="py-1 text-gray-700 dark:text-gray-300" aria-labelledby="dropdown">
            <li>
              <a
                (click)="logout()"
                class="alink block py-2 px-4 text-sm hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                >{{ 'NAV.LOGOUT' | translate }}</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>

  <aside
    class="fixed top-0 left-0 z-40 w-64 h-screen pt-14 transition-transform -translate-x-full bg-white border-r border-gray-200 md:translate-x-0 dark:bg-gray-800 dark:border-gray-700"
    aria-label="Sidenav"
    id="drawer-navigation">
    <div class="overflow-y-auto py-5 px-3 h-full bg-white dark:bg-gray-800">
      <ul class="space-y-2">
        <li *ngIf="canSeeDashboard">
          <a
            routerLink="/dashboard"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{exact: true}"
            class="flex items-center p-2 text-base font-medium text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-white group">
            <svg
              aria-hidden="true"
              class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
              fill="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                d="M3 6a3 3 0 0 1 3-3h2.25a3 3 0 0 1 3 3v2.25a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm9.75 0a3 3 0 0 1 3-3H18a3 3 0 0 1 3 3v2.25a3 3 0 0 1-3 3h-2.25a3 3 0 0 1-3-3V6ZM3 15.75a3 3 0 0 1 3-3h2.25a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2.25Zm9.75 0a3 3 0 0 1 3-3H18a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3h-2.25a3 3 0 0 1-3-3v-2.25Z"
                clip-rule="evenodd" />
            </svg>
            <span class="ml-3">{{ 'NAV.DASHBOARD' | translate }}</span>
          </a>
        </li>

        <!--
        <li *ngIf="role == 1">
          <a
            routerLink="/transfer"
            class="flex items-center p-2 text-base font-medium text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2.5"
              stroke="currentColor"
              class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9 12.75l3 3m0 0l3-3m-3 3v-7.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>

            <span class="flex-1 ml-3 text-left whitespace-nowrap">Transfer</span>
          </a>
        </li>
        -->

        <li>
          <a
            routerLink="/hausverwaltungen"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{exact: false}"
            class="flex items-center p-2 text-base font-medium text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
            <mat-icon class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white">apartment</mat-icon>

            <span class="flex-1 ml-3 text-left whitespace-nowrap">{{ 'NAV.PROPERTY_MANAGEMENT' | translate }}</span>
          </a>
        </li>

        <li>
          <a
            routerLink="/clients"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{exact: false}"
            class="flex items-center p-2 text-base font-medium text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
            <mat-icon class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white">domain</mat-icon>

            <span class="flex-1 ml-3 text-left whitespace-nowrap">{{ 'NAV.CLIENTS' | translate }}</span>
          </a>
        </li>

        <li>
          <a
            routerLink="/standorte"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{exact: false}"
            class="flex items-center p-2 text-base font-medium text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2.5"
              stroke="currentColor"
              class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
            </svg>

            <span class="flex-1 ml-3 text-left whitespace-nowrap">{{ 'NAV.LOCATIONS' | translate }}</span>
          </a>
        </li>



        <li>
                     <a
             routerLink="/kontrolltermine"
             routerLinkActive="active-nav-item"
             [routerLinkActiveOptions]="{exact: false}"
             class="flex items-center p-2 text-base font-medium text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2.5"
              stroke="currentColor"
              class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z" />
            </svg>

            <span class="flex-1 ml-3 text-left whitespace-nowrap">{{ 'NAV.APPOINTMENTS' | translate }}</span>
          </a>
        </li>

        <li>
          <a
            routerLink="/rechnungslauf"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{exact: false}"
            class="flex items-center p-2 text-base font-medium text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2"
              stroke="currentColor"
              class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M14.25 12.75a3 3 0 100 4.5M8.25 14.25h4.5M8.25 15.75h4.5" />
            </svg>

            <span class="flex-1 ml-3 text-left whitespace-nowrap">{{ 'NAV.BILLING_RUN' | translate }}</span>
          </a>
        </li>





        <!--
        <li *ngIf="role == 1">
          <a
            routerLink="/vstv"
            class="flex items-center p-2 text-base font-medium text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-white group">
            <svg
              aria-hidden="true"
              class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.707 7.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l2-2a1 1 0 00-1.414-1.414L11 7.586V3a1 1 0 10-2 0v4.586l-.293-.293z"></path>
              <path
                d="M3 5a2 2 0 012-2h1a1 1 0 010 2H5v7h2l1 2h4l1-2h2V5h-1a1 1 0 110-2h1a2 2 0 012 2v10a2 2 0 01-2 2H5a2 2 0 01-2-2V5z"></path>
            </svg>
            <span class="ml-3">VSTV Export</span>
          </a>
        </li>
        -->

        <li>
          <a
            routerLink="/reports"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{exact: false}"
            class="flex items-center p-2 text-base font-medium text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
            <svg
              aria-hidden="true"
              class="w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M2 10a8 8 0 018-8v8h8a8 8 0 11-16 0z"></path>
              <path d="M12 2.252A8.014 8.014 0 0117.748 8H12V2.252z"></path>
            </svg>
            <span class="ml-3">{{ 'NAV.REPORTS' | translate }}</span>
          </a>
        </li>



        <li>
          <a
            routerLink="/techniker"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{exact: false}"
            class="flex items-center p-2 text-base font-medium text-gray-900 rounded-lg dark:text-white hover:bg-gray-100 dark:hover:bg-gray-700 group">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2.5"
              stroke="currentColor"
              class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 group-hover:text-gray-900 dark:text-gray-400 dark:group-hover:text-white">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
            </svg>

            <span class="flex-1 ml-3 text-left whitespace-nowrap">{{ 'NAV.TECHNICIANS' | translate }}</span>
          </a>
        </li>


      </ul>

      <ul class="pt-3 mt-5 space-y-2 border-t border-gray-200 dark:border-gray-700">
        <li *ngIf="showExtendedVersion">
          <a
            routerLink="/help"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{exact: true}"
            class="flex items-center p-2 text-base font-medium text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-white group">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2.5"
              stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z" />
            </svg>

            <span class="ml-3">{{ 'NAV.HELP' | translate }}</span>
          </a>
        </li>

        <li>
          <a
            routerLink="/support"
            routerLinkActive="active-nav-item"
            [routerLinkActiveOptions]="{exact: true}"
            class="flex items-center p-2 text-base font-medium text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-white group">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 01.865-.501 48.172 48.172 0 003.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0012 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018z" />
            </svg>

            <span class="ml-3">{{ 'NAV.SUPPORT' | translate }}</span>
          </a>
        </li>

        <li *ngIf="canSeeSettings">
          <button
            type="button"
            class="flex items-center p-2 w-full text-base font-medium text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
            aria-controls="dropdownMenu"
            data-collapse-toggle="dropdownMenu"
            (click)="toggleDropdown()">
            <svg
              aria-hidden="true"
              class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                d="M11.49 3.17c-.38-1.56-2.6-1.56-2.98 0a1.532 1.532 0 01-2.286.948c-1.372-.836-2.942.734-2.106 2.106.54.886.061 2.042-.947 2.287-1.561.379-1.561 2.6 0 2.978a1.532 1.532 0 01.947 2.287c-.836 1.372.734 2.942 2.106 2.106a1.532 1.532 0 012.287.947c.379 1.561 2.6 1.561 2.978 0a1.533 1.533 0 012.287-.947c1.372.836 2.942-.734 2.106-2.106a1.533 1.533 0 01.947-2.287c1.561-.379 1.561-2.6 0-2.978a1.532 1.532 0 01-.947-2.287c.836-1.372-.734-2.942-2.106-2.106a1.532 1.532 0 01-2.287-.947zM10 13a3 3 0 100-6 3 3 0 000 6z"
                clip-rule="evenodd"></path>
            </svg>
            <span class="flex-1 ml-3 text-left whitespace-nowrap">{{ 'NAV.SETTINGS' | translate }}</span>
            <svg
              aria-hidden="true"
              class="w-6 h-6"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                clip-rule="evenodd"></path>
            </svg>
          </button>

          <!-- ul id="dropdown-settings" class="hidden py-2 space-y-2" style="padding-left: 30px" -->
          <ul
            #dropdownMenu
            id="dropdownMenu"
            [ngClass]="{ hidden: !isDropdownOpen, block: isDropdownOpen }"
            class="py-2 space-y-2"
            style="padding-left: 30px">
            
            <li>
              <a
                routerLink="/indikatoren"
                routerLinkActive="active-nav-item"
                [routerLinkActiveOptions]="{exact: true}"
                class="flex items-center p-2 pl-11 w-full text-base font-medium text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
                >{{ 'NAV.INDICATORS' | translate }}</a
              >
            </li>
            <li *ngIf="isSuperUser || isCompAdmin">
              <a
                routerLink="/mitarbeiter"
                routerLinkActive="active-nav-item"
                [routerLinkActiveOptions]="{exact: true}"
                class="flex items-center p-2 pl-11 w-full text-base font-medium text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
                >
                {{ 'NAV.EMPLOYEES' | translate }}
              </a>
            </li>
            <li *ngIf="isSuperUser">
              <a
                routerLink="/berechtigungen"
                routerLinkActive="active-nav-item"
                [routerLinkActiveOptions]="{exact: true}"
                class="flex items-center p-2 pl-11 w-full text-base font-medium text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
                >
                {{ 'NAV.PERMISSIONS' | translate }}
              </a>
            </li>
            
            <li>
              <a
                routerLink="/stammdaten"
                routerLinkActive="active-nav-item"
                [routerLinkActiveOptions]="{exact: true}"
                class="flex items-center p-2 pl-11 w-full text-base font-medium text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
                >{{ 'NAV.MASTER_DATA' | translate }}</a
              >
            </li>
            <li>
              <a
                routerLink="/system-settings"
                routerLinkActive="active-nav-item"
                [routerLinkActiveOptions]="{exact: true}"
                class="flex items-center p-2 pl-11 w-full text-base font-medium text-gray-900 rounded-lg transition duration-75 group hover:bg-gray-100 dark:text-white dark:hover:bg-gray-700"
                >{{ 'NAV.SYSTEM' | translate }}</a
              >
            </li>
            
          </ul>
        </li>
      </ul>

      <ul class="pt-3 mt-5 space-y-2 border-t border-gray-200 dark:border-gray-700">
        <li>
          <a
            (click)="logout()"
            class="alink flex items-center p-2 text-base font-medium text-gray-900 rounded-lg transition duration-75 hover:bg-gray-100 dark:hover:bg-gray-700 dark:text-white group">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="2.5"
              stroke="currentColor"
              class="flex-shrink-0 w-6 h-6 text-gray-500 transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-white">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9" />
            </svg>

            <span class="ml-3">Abmelden</span>
          </a>
        </li>
      </ul>
    </div>
  </aside>

  <main class="p-4 md:ml-64 h-auto pt-20 h-full">
    <section>
      <div class="py-8 px-2 lg:py-16 lg:px-6">
        <div class="text-gray-500 sm:text-lg dark:text-gray-400">
          <router-outlet></router-outlet>
        </div>
      </div>
    </section>
  </main>

  <!-- FOOTER -->
  <footer class="p-1 md:ml-64 h-auto pt-00">
    <div class="mx-auto max-w-7xl px-6 py-6 md:flex md:items-center md:justify-between lg:px-8">
      <div class="flex justify-center space-x-6 md:order-2">
        <p class="text-center text-xs leading-5 text-gray-500">
          <span>Angemeldet: </span> <span class="text-gray-700">{{ username }}</span> als
          <span *ngIf="role == 1" class="text-gray-700">Administrator / {{ role }}</span>
          <span *ngIf="role == 2" class="text-gray-700">Company Admin / {{ role }}</span>
          <span *ngIf="role == 11" class="text-gray-700">Büro</span>
        </p>
      </div>
      <div class="mt-8 md:order-1 md:mt-0">
        <p class="text-center text-xs leading-5 text-gray-500">
          &copy; {{ currentYear }} AppFactory Vienna - Alle Rechte vorbehalten.
        </p>
      </div>
    </div>
  </footer>
</div>

<!-- Show loading/redirect message when user is not logged in -->
<div *ngIf="!authQuery.isLoggedIn" class="min-h-screen flex items-center justify-center bg-gray-50">
  <div class="text-center">
    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
    <p class="text-gray-600">Redirecting to login...</p>
  </div>
</div>
